var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tags.length)?_c('div',{staticClass:"ArticleTagList"},[_c('div',{staticClass:"ArticleTagList__title mb-3"},[_vm._v(" "+_vm._s(_vm.$t('ArticleTagList.heading'))+" ")]),_c('div',_vm._l((_vm.tags),function(tag){return _c('ArticleTagListTag',{key:tag._id,attrs:{"tag":tag}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }